<script setup lang="ts">

import { ref, watch } from 'vue';
import { useApi } from "@domain/Security";
import { useRouter } from "@library/Services";
import { Transition as Transitions } from '@app/Components/Transition';
import { useJupiterProps } from "@/modules/Jupiter";

import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue';
import dayjs from "dayjs";

const api = useApi();
const jupiterProps = useJupiterProps();

const router = useRouter();
const pageTitle = ref( router.current.value.meta.title );
const getTime = () => dayjs().format( 'HH:mm' );

const toggleDarkMode = () =>
{
    jupiterProps.isDarkMode = true;
};

const currentTime = ref( getTime() );
setInterval( () =>
{
    currentTime.value = getTime()
}, 1000 );

watch( () => router.current.value.path, path =>
{
    const route = router.vueRouter.getRoutes().find( (x:any) => x.path == path );
    if( route != null )
    {
        pageTitle.value = route.meta.title;
    }
}, { immediate: true } );

</script>

<template>

    <div class="pb-2 text-white bg-primary-500 dark:bg-gray-900  z-50">
        <div class="flex items-center">
            <div class="px-4">{{ currentTime }}</div>
            <div class="flex-1"></div>
            <img class="-mr-4" 
                 src="@/assets/images/phone/phone-state.png" 
                 :style="{ filter: `brightness(${ jupiterProps.isDarkMode ? '1' : '0.1' })` }" />
        </div>
        <div class="flex items-center">
            <Menu as="div" v-slot="{open}" class="relative inline-block text-left">
                <MenuButton class="inline-flex w-full justify-center items-center focus:outline-none">
                    <div class="w-full h-full rounded-full border border-gray-200 dark:border-gray-900 ml-4">
                        <img src="@/assets/images/phone/phone-car-icon.png" />
                    </div>
                </MenuButton>
                <Transitions.Menu>
                    <MenuItems class="menu left-2 w-56 origin-top-left p-0 rounded-lg overflow-hidden shadow-2xl">
                        <MenuItem>
                            <div @click="toggleDarkMode()" class="p-2 hover:!bg-gray-600 cursor-pointer">{{ jupiterProps.isDarkMode ? 'Light Mode' : 'Dark Mode'}}</div>   
                        </MenuItem>
                        <MenuItem>
                            <div @click="api.logout()" class="p-2 hover:!bg-gray-600 cursor-pointer font-bold">Sign out</div>   
                        </MenuItem>
                    </MenuItems>
                </Transitions.Menu>
            </Menu>

            <div class="flex-1 text-center text-lg opacity-0">{{ pageTitle }}</div>
            <div class="w-8"></div>
        </div>
    </div>    

</template>